import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-black text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block border-2 border-red-600 rounded-full px-6 py-2 text-sm font-semibold text-red-500">
            Since 2024
          </div>
        </div>

        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-8">
            Tarinamme
          </h2>
          <p className="text-lg text-white/80 leading-relaxed text-center max-w-4xl mx-auto mb-16">
            Ravintola Vilppula on uusi, energinen ravintola Vilppulan sydämessä. 
            Intohimonamme on tarjota aitoja ja rehellisiä makuja: kiviuunipizzat, 
            maukkaat kebabit ja turkkilaiset grillit valmistuvat käsissämme suurella 
            sydämellä. Haluamme olla paikka, johon on helppo tulla viihtymään perheen 
            ja ystävien kanssa hyvän ruoan äärelle.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <div className="bg-gradient-to-br from-red-950/30 to-red-900/20 border border-red-900/30 rounded-lg p-8 text-center hover:scale-105 transition-transform duration-300">
              <div className="text-5xl font-bold text-red-500 mb-2">50+</div>
              <div className="text-lg text-white/70">Dishes</div>
            </div>
            <div className="bg-gradient-to-br from-red-950/30 to-red-900/20 border border-red-900/30 rounded-lg p-8 text-center hover:scale-105 transition-transform duration-300">
              <div className="text-5xl font-bold text-red-500 mb-2">100%</div>
              <div className="text-lg text-white/70">High Quality Ingredients</div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div className="relative group overflow-hidden rounded-lg">
              <img
                src="https://customer-assets.emergentagent.com/job_vilppula-pizza/artifacts/1vrxvikw_unnamed.webp"
                alt="Restaurant Interior"
                className="w-full h-[400px] object-cover rounded-lg transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-lg" />
            </div>
            <div className="text-center md:text-left">
              <div className="text-6xl text-red-500 mb-4">"</div>
              <h3 className="text-3xl font-bold mb-4">Best Pizzeria in Town</h3>
              <p className="text-lg text-white/70 mb-6">
                Tutustu laajaan valikoimaamme
              </p>
              <button
                onClick={() => {
                  const element = document.getElementById('menu');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105"
              >
                Katso Menu
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
